import { NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "./core/guards/auth.guard";
import { GuestGuard } from "./core/guards/guest.guard";
import { RoleGuard } from "./core/guards/role.guard";
import { PublicLayoutComponent } from "./layouts/public-layout/public-layout.component";
import { DepartmentDashboardComponent } from "./dashboard/dashboard.component";
import { Gallery } from "./features/public/gallery/gallery";
import { Artform } from "./features/public/artform/artform";
import { Programs } from "./features/public/programs/programs";
import { SiteLaunchGuard } from "./core/guards/site-launch.guard";

const routes: Routes = [
  {
    path: "",
    component: PublicLayoutComponent,
    children: [
      { path: "gallery", component: Gallery },
      { path: "artform", component: Artform },
      { path: "programs", component: Programs },
      {
        path: "",
        loadChildren: () =>
          import("./features/public/public.module").then((m) => m.PublicModule),
      },
    ],
  },
  {
    path: "login",
    children: [
      {
        path: "",
        loadChildren: () =>
          import("./dashboard/auth/auth.module").then((m) => m.AuthModule),
      },
    ],
  },
  {
    path: "forgot-password",
    canActivate: [GuestGuard],
    loadChildren: () =>
      import("./dashboard/auth/forgot-password/forgot-password.module").then(
        (m) => m.ForgotPasswordModule,
      ),
  },
  {
    path: "register",
    canActivate: [GuestGuard, SiteLaunchGuard],
    loadChildren: () =>
      import("./dashboard/auth/register/register.module").then(
        (m) => m.RegisterModule,
      ),
  },

  {
    path: "department",
    canActivate: [AuthGuard, RoleGuard],
    component: DepartmentDashboardComponent,
    children: [
      {
        path: "",
        loadChildren: () =>
          import("./dashboard/department.module").then(
            (m) => m.DepartmentModule,
          ),
      },
    ],
  },
  {
    path: "portal",
    canActivate: [AuthGuard, RoleGuard],
    loadChildren: () =>
      import("./dashboard/portal/portal.module").then((m) => m.PortalModule),
  },

  { path: "**", redirectTo: "" },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      scrollPositionRestoration: "top",
      enableTracing: false,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
